import { render, staticRenderFns } from "./NuevoSocketVideo.vue?vue&type=template&id=5fc83690&scoped=true&"
import script from "./NuevoSocketVideo.vue?vue&type=script&lang=js&"
export * from "./NuevoSocketVideo.vue?vue&type=script&lang=js&"
import style0 from "./NuevoSocketVideo.vue?vue&type=style&index=0&id=5fc83690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc83690",
  null
  
)

export default component.exports